export default __webpack_public_path__ + "static/FReg-4x3-Tools-b5625052a630a4c7fd2aa1f044c4b175.jpg";